export default __webpack_public_path__ + "static/media/img-0446-luxembourg-full-face.d92d349f.png";